import { useState } from "react";
import ItemSelectSizeGrouped from "components/item/ItemSelectSizeGrouped";
import {
  useItemDetailsWithSizes,
  useBulkUpdatePackRatios,
} from "http-hooks/agitem/useAgitem";
import Input from "components/ui/Input";

export default function PackRatio() {
  const [selectedItemDetail, setSelectedItemDetail] = useState(null);
  const [selectedItems, setSelectedItems] = useState(null);

  const { mutateAsync: fetchItemSizes, isPending: isLoadingSizes } =
    useItemDetailsWithSizes();

  const { mutate: bulkUpdate, isLoading: isUpdating } = useBulkUpdatePackRatios(
    {}
  );

  const handleItemChange = async (selectedItem) => {
    setSelectedItemDetail(selectedItem);

    if (selectedItem?.value) {
      try {
        const itemSizes = await fetchItemSizes(selectedItem.value);
        if (itemSizes) {
          const convertedItems = itemSizes.map((item) => ({
            ...item,
            packratio: item.packratio ? Math.round(100 / item.packratio) : 0,
          }));
          setSelectedItems(convertedItems);
        }
      } catch (error) {
        console.error("Error fetching item sizes:", error);
        setSelectedItems(null);
      }
    } else {
      setSelectedItems(null);
    }
  };

  const setPackRatio = (agitemdtlId, value) => {
    setSelectedItems((prevItems) =>
      prevItems?.map((item) =>
        item.agitemdtlId === agitemdtlId ? { ...item, packratio: value } : item
      )
    );
  };

  const handleSave = () => {
    const updates = selectedItems.map((item) => ({
      agitemdtlId: item.agitemdtlId,
      packratio: item.packratio ? (100 / item.packratio).toFixed(3) : 0,
    }));

    bulkUpdate(updates);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="font-semibold leading-6 text-3xl text-gray-900">
            Item Master Pack Ratio
          </h1>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 mt-6">
        <div className="bg-white rounded-lg">
          <ItemSelectSizeGrouped
            value={selectedItemDetail}
            onChange={handleItemChange}
            placeholder="Select item..."
            label="Item Name"
            requireVendor={false}
          />
        </div>
      </div>

      {isLoadingSizes && selectedItemDetail && (
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="bg-white rounded-lg p-8 text-center">
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mr-3"></div>
                  <span className="text-gray-600">Loading items...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedItems && !isLoadingSizes ? (
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <h2 className="block text-md font-medium leading-6 text-gray-900">
                Number of Cases
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mt-2">
                {selectedItems?.map((item) => (
                  <div
                    key={item.agitemdtlId}
                    className="bg-white rounded-lg p-3 border border-gray-200"
                  >
                    <Input
                      type="number"
                      value={item.packratio}
                      onChange={(e) =>
                        setPackRatio(item.agitemdtlId, e.target.value)
                      }
                      label={item.sz + " " + item.szuom}
                      placeholder="Number of cases"
                    />
                  </div>
                ))}
              </div>
              <button
                type="button"
                onClick={handleSave}
                disabled={isUpdating}
                className="rounded-md bg-gray-700 px-6 mt-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700 disabled:opacity-50"
              >
                {isUpdating ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
